"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRatingsRoutine = exports.clearPostsRoutine = exports.getPostsRoutine = void 0;
var redux_saga_routines_1 = require("redux-saga-routines");
// creating routine
exports.getPostsRoutine = (0, redux_saga_routines_1.createRoutine)('feed/GET_POSTS');
// export const mapPostsInfoRoutine = createRoutine("feed/MAP_POSTS_INFO");
exports.clearPostsRoutine = (0, redux_saga_routines_1.createRoutine)('feed/CLEAR_POSTS');
exports.getRatingsRoutine = (0, redux_saga_routines_1.createRoutine)('feed/GET_RATINGS');
